import React from 'react';

const AddressItem = ({ address, onEdit, onDelete }) => (
  <div className={`border rounded-lg p-4 transition-all ${
    address.isDefault 
      ? 'border-blue-500 bg-blue-50' 
      : 'border-gray-200 hover:border-blue-300 hover:shadow-md'
  }`}>
    {address.isDefault && (
      <span className="inline-block px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800 mb-2">
        Default Address
      </span>
    )}
    
    <div className="space-y-1">
      <h3 className="font-medium text-gray-800">{address.fullName}</h3>
      <p className="text-gray-600">{address.phone}</p>
      <p className="text-gray-600">{address.addressLine1}</p>
      {address.addressLine2 && <p className="text-gray-600">{address.addressLine2}</p>}
      <p className="text-gray-600">
        {address.city}, {address.state} {address.zipCode}
      </p>
      <p className="text-gray-600">{address.country}</p>
    </div>
    
    <div className="mt-3 flex space-x-2">
      <button 
        onClick={()=>{onEdit(address)}} 
        className="text-sm text-blue-600 hover:text-blue-800 hover:underline"
      >
        Edit
      </button>
      <button 
        onClick={()=>onDelete(address)} 
        className="text-sm text-red-600 hover:text-red-800 hover:underline"
      >
        Delete
      </button>
    </div>
  </div>
);

export default AddressItem;